import { render, staticRenderFns } from "./TvChannel.vue?vue&type=template&id=1b4eb476"
import script from "./TvChannel.vue?vue&type=script&lang=js"
export * from "./TvChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports